<template>
  <svg
    class="cart__timeClock"
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="15"
      cy="15"
      r="14"
      fill="white"
      stroke="#545454"
      stroke-width="2"
    />
    <path
      d="M15.0586 6L15.0586 17L22 19.5"
      stroke="#545454"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: 'CartClock',
};
</script>
